module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAAMVJREFUKBWV0aEOwjAQBuBem+0BeIpZNIIQBmoOA4IHQ6BBgEOOLBNo3oQHYIGjP6RklPUKTZqa/767tkpFVl5v+tiRmCIpAODGqkTGkMrL4eIcygchhzBzD8VEdJGwTqiNWOAKyIKphH1BPqKZZoDuxHsJ+4C6kONofgA0rraFhL0hCQGEJWFP6BfkRYUxmla7rKHmhN/Bw+JN3HVcsX/6kyWcDLRFlv8gQNEIDdEYtTC0Mena3m9FpCexSdqTIYsa1MJ4AOTzrUo/6eWbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/With/icon-right-arrow-1.png
// module id = Lpc6
// module chunks = 0